$(document).ready(function(){

  $('.mobile-nav-icon').click(function() {
    $('.navigation').slideToggle();
    $(this).toggleClass('mobile-nav-icon-active');
  });

  window.addEventListener("resize", function() {
    if (screen.width < 1000 && screen.height > 1000) {
      if ($('.mobile-interaction-link').css('display') === 'block') {
        $('.navigation').hide();
      } else {
        $('.navigation').show();
      }
    }
  }, false);

  // Prescribing Resource Categories
  $('.category-list-tab h2.tab-heading').click(function() {
    $(this).next().slideToggle().toggleClass('active-tab');
    $(this).toggleClass('active-tab');
  });

  // Prescribing Resource Copy
  $('.copy-button').click(function() {
    var textAreaId = $(this).data('id')
    $(this).children().first().css({"visibility": "visible"})
    navigator.clipboard.writeText($(this).data('id'));
    setTimeout( () => {
      $(this).children().first().css({"visibility": "hidden"})
    }, 2000);
  });

  // Video Categories
  if ($('.video-list-tab h2.tab-heading').length > 0){
    $('.video-list-tab h2.tab-heading').click(function() {
      $(this).next().slideToggle().toggleClass('active-tab');
      $(this).toggleClass('active-tab');
    });
  }

  $('.video-button-wrapper a').click(function() {
    mixpanel.track("Watched Video", { "name": $(this).data("name"), "type": $(this).data("type") });
  })

  $('.close-reveal-modal').click(function(){
    var iframe = $(this).parent().children().find('iframe')
    var src = iframe.attr('src')
    iframe.attr('src', src)
  });
  
  $(document).on('click', '.reveal-modal-bg', function() {
    // Find all open iframes and refresh them
    $('iframe').each(function() {
      var src = $(this).attr('src');
      $(this).attr('src', src);
    });
  });

  // Site News Header Buttons
  $('.header-button-group a').click(function() {
    console.log('hi')
    $('.header-button-group a').removeClass('button-group-active');
    $(this).toggleClass('button-group-active');
  });

});

